<div class="mainDiv">
  <div class="row">
    <div
      class="mainTxt d-flex justify-content-center mt-3"
      style="color: #f3a43f; font-size: 48px; font-weight: 500"
    >
      Change Password
    </div>
  </div>

  <div class="container mt-4 d-flex justify-content-center px-3">
    <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()" class="card p-4 shadow-sm">
      <!-- Old Password Field -->
      <div class="form-group mb-4">
        <label for="oldPassword">Old Password</label>
        <div class="password-container">
          <input
            [type]="hideOldPassword ? 'password' : 'text'"
            class="form-control form_Input mt-2"
            id="oldPassword"
            formControlName="oldPassword"
            placeholder="Enter Old password"
          />
          <img
            src="{{ hideOldPassword ? 'assets/images/eye-slash.svg' : 'assets/images/eye.svg' }}"
            alt="Toggle password visibility"
            class="toggle-password"
            (click)="toggleOldPassword()"
          />
        </div>
      </div>

      <!-- New Password Field -->
      <div class="form-group mb-4">
        <label for="newPassword">New Password</label>
        <div class="password-container">
          <input
            [type]="hideNewPassword ? 'password' : 'text'"
            class="form-control form_Input mt-2"
            id="newPassword"
            formControlName="newPassword"
            placeholder="Enter new password"
          />
          <img
            src="{{ hideNewPassword ? 'assets/images/eye-slash.svg' : 'assets/images/eye.svg' }}"
            alt="Toggle password visibility"
            class="toggle-password"
            (click)="toggleNewPassword()"
          />
        </div>
      </div>

      <!-- Confirm Password Field -->
      <div class="form-group mb-4">
        <label for="confirmPassword">Confirm Password</label>
        <div class="password-container">
          <input
            [type]="hideConfirmPassword ? 'password' : 'text'"
            class="form-control form_Input mt-2"
            id="confirmPassword"
            formControlName="confirmPassword"
            placeholder="Enter new password"
          />
          <img
            src="{{ hideConfirmPassword ? 'assets/images/eye-slash.svg' : 'assets/images/eye.svg' }}"
            alt="Toggle password visibility"
            class="toggle-password"
            (click)="toggleConfirmPassword()"
          />
        </div>
      </div>

      <!-- Save Button -->
      <button
        type="submit"
        class="btn btn-primary btn-block"
        [disabled]="!passwordForm.valid"
      >
        Save
      </button>
    </form>
  </div>
</div>
